import React, { useEffect, useState } from 'react';
import Spacer from 'features/shared/Spacer';
import plural from 'utils/pluralize';
import { NumberBlock, NumberElement, Plate, Row, SubHeader, Unit } from 'features/shared/ui/Page';
import styled from 'styled-components';
import { KnowledgeMonitoringApi } from 'api';
import { TotalStatistics } from 'features/monitoring/models';
import LoaderComponent from 'features/shared/Loader';

const Text = styled.div`
  margin-top: 4px;
  font-size: 16px;
  line-height: 22px;
  color: rgba(9, 21, 38, 0.6);
`;

const Component = ({ isRegion }: { isRegion: boolean }) => {
  const [totals, setTotals] = useState<TotalStatistics>();

  useEffect(() => {
    async function fetch() {
      const totals = await KnowledgeMonitoringApi.getTotals();
      setTotals(totals);
    }

    fetch();
  }, []);

  const studentsCount = totals?.students_count || 0;
  const teachersCount = totals?.teachers_count || 0;

  return (
    <Plate>
      <SubHeader>Основные показатели по {isRegion ? 'региону' : 'муниципалитету'}</SubHeader>
      <Spacer size={32} />
      {!totals ? (
        <LoaderComponent />
      ) : (
        <>
          <Row>
            <NumberBlock>
              <NumberElement>{studentsCount}</NumberElement>
              <Spacer size={8} inline />
              <Unit>{plural(studentsCount, 'Ученик', 'Ученика', 'Учеников')}</Unit>
              <Spacer size={8} />
              <Text>{plural(studentsCount, 'прошел', 'прошли', 'прошли')} тестирование в рамках Среза знаний</Text>
            </NumberBlock>
            <Spacer size={24} />
            <NumberBlock>
              <NumberElement>{teachersCount}</NumberElement>
              <Spacer size={8} inline />
              <Unit>{plural(teachersCount, 'Учитель', 'Учителя', 'Учителей')}</Unit>
              <Spacer size={8} />
              <Text>{plural(teachersCount, 'провел', 'провели', 'провели')} тестирование для Среза знаний</Text>
            </NumberBlock>
          </Row>
        </>
      )}
    </Plate>
  );
};

export default Component;
